import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { db } from '../Firebase';
import { collection, onSnapshot, doc, setDoc, deleteDoc } from 'firebase/firestore';
import { 
  Plus, 
  Trash2, 
  Edit, 
  X, 
  Building, 
  Phone, 
  Clock, 
  User, 
  MapPin, 
  Search
} from 'lucide-react';
import Swal from 'sweetalert2';
import { motion, AnimatePresence } from 'framer-motion';

const defaultBranches = [
  {
    id: 'head-office-palus',
    city: 'Head Office, Palus',
    name: 'Sangram Patsanstha Head Office',
    address: 'Sangram Bhavan Plot No. 187/1 2nd Floor, Tasgaon Karad Road, Industrial Estate, Palus.',
    phone: '9075251097',
    coords: { x: 34, y: 44 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. S. R. Patil',
    isHQ: true
  },
  {
    id: 'audyogik-vasahat',
    city: 'Audyogik Vasahat',
    name: 'Audyogik Vasahat Branch',
    address: 'Sangram Bhavan Plot No. 187/1 Second Floor, Tasgaon Karad Road, Industrial Estate, Palus.',
    phone: '9075251097',
    coords: { x: 40, y: 70 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Smt. S. A. Pawar'
  },
  {
    id: 'sawantpur-vasahat',
    city: 'Sawantpur Vasahat',
    name: 'Sawantpur Extension Branch',
    address: 'Near the Satyavijay Bank, Sawantpur Colony.',
    phone: '8007294004',
    coords: { x: 50, y: 84 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. M. A. Sawant'
  },
  {
    id: 'yelavi',
    city: 'Yelavi',
    name: 'Yelavi Village Branch',
    address: 'Near Sangli District Central Bank, Yelavi.',
    phone: '8007054009',
    coords: { x: 56, y: 56 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. K. D. Patil'
  },
  {
    id: 'tasgaon',
    city: 'Tasgaon',
    name: 'Tasgaon Town Branch',
    address: 'Joshi Galli, Aditya Bunglow, Tasgaon.',
    phone: '9172415910',
    coords: { x: 54, y: 44 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Smt. P. R. Jadhav'
  },
  {
    id: 'savalaj',
    city: 'Savalaj',
    name: 'Savalaj Bazar Branch',
    address: 'Nikam Galli, Hankare Building, Near Hotel Aashirvaad,Savlaj.',
    phone: '8007044008',
    coords: { x: 72, y: 48 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. S. K. Shinde'
  },
  {
    id: 'islampur',
    city: 'Ishwarpur',
    name: 'Ishwarpur City Branch',
    address: 'Old Vegetable Market, Bramhanpuri, Near Gosavi Hospital, Ishwarpur.',
    phone: '8007204010',
    coords: { x: 24, y: 50 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. R. G. Bhosale'
  },
  {
    id: 'shirala',
    city: 'Shirala',
    name: 'Shirala Valley Branch',
    address: 'Laxmi Chowk, Nath Road, Mangale Road, Shirala.',
    phone: '9049634610',
    coords: { x: 10, y: 45 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. A. B. Naik'
  },
  {
    id: 'andhali',
    city: 'Andhali',
    name: 'Andhali Gramin Branch',
    address: 'Shri. Chhatrapati Shivaji Maharaj Chowk, Aandhali.',
    phone: '8007105003',
    coords: { x: 88, y: 25 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. S. V. More'
  },
  {
    id: 'kadegaon',
    city: 'Kadegaon',
    name: 'Kadegaon Taluka Branch',
    address: 'Kadegaon Tadsar Road Maitreya Park Kadegaon',
    phone: '8007565001',
    coords: { x: 36, y: 22 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. V. M. Pawar'
  },
  {
    id: 'vita',
    city: 'Vita',
    name: 'Vita Town Branch',
    address: 'Muktangan Library, near Vita Karad Road, Vita.',
    phone: '9922128738',
    coords: { x: 52, y: 30 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. H. D. Deshmukh'
  },
  {
    id: 'bhilawadi',
    city: 'Bhilawadi',
    name: 'Bhilawadi Riverbank Branch',
    address: 'Ashta Tasgaon Road ,Opposite Bharati Bazaar, 1st Floor Bhilawadi.',
    phone: '8007895005',
    coords: { x: 32, y: 62 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. G. N. Kulkarni'
  },
  {
    id: 'sangli',
    city: 'Sangli',
    name: 'Sangli City Branch',
    address: 'Ram Mandir, Civil Hospital Road, Aditya Sai Land Mark Gala No. 1.',
    phone: '9503454073',
    coords: { x: 46, y: 76 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. S. S. Gaikwad'
  },
  {
    id: 'manerajuri',
    city: 'Manerajuri',
    name: 'Manerajuri Village Branch',
    address: 'In Front of S. T. Stand , behind of  I. C. I. C. A. T. M, Manerajuri.',
    phone: '9172387726',
    coords: { x: 68, y: 62 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. K. D. Mane'
  },
  {
    id: 'palus-shahar',
    city: 'Palus Shahar',
    name: 'Palus City Branch',
    address: 'Near Nagoba Temple, Main Road, Palus.',
    phone: '8007155002',
    coords: { x: 34, y: 48 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. P. K. Sutar'
  },
  {
    id: 'takari',
    city: 'Takari',
    name: 'Takari Junction Branch',
    address: 'Near Gram Panchayat, Main Road, Takari.',
    phone: '8263957058',
    coords: { x: 20, y: 28 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. D. S. Sutar'
  },
  {
    id: 'aalsand',
    city: 'Aalsand',
    name: 'Aalsand Hilly Branch',
    address: 'Near Laxmi Temple, Main Road, Aalsand',
    phone: '8007444006',
    coords: { x: 48, y: 18 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. V. S. Salunkhe'
  },
  {
    id: 'malwadi',
    city: 'Malwadi',
    name: 'Malwadi Rural Branch',
    address: 'Near Patil Dairy, Malwadi.',
    phone: '8007095006',
    coords: { x: 28, y: 38 },
    timing: '10:00 AM - 5:00 PM',
    manager: 'Shri. S. V. Patil'
  }
];

const BranchManager = () => {
  const [branches, setBranches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editBranch, setEditBranch] = useState(null);
  
  const [formData, setFormData] = useState({
    city: '',
    name: '',
    address: '',
    phone: '',
    timing: '10:00 AM - 5:00 PM',
    manager: '',
    coordsX: '',
    coordsY: '',
    isHQ: false
  });

  // Listen to Firestore branches
  useEffect(() => {
    const unsub = onSnapshot(collection(db, 'branches'), async (snapshot) => {
      if (snapshot.empty) {
        // Seeding database with original branches
        setLoading(true);
        try {
          for (const item of defaultBranches) {
            await setDoc(doc(db, 'branches', item.id), item);
          }
        } catch (e) {
          console.error("Error seeding default branches:", e);
        }
      } else {
        const list = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        // Sort HQ first, then by city name
        list.sort((a, b) => {
          if (a.isHQ && !b.isHQ) return -1;
          if (!a.isHQ && b.isHQ) return 1;
          return a.city.localeCompare(b.city);
        });
        setBranches(list);
        setLoading(false);
      }
    });
    return () => unsub();
  }, []);

  const handleOpenAdd = () => {
    setEditBranch(null);
    setFormData({
      city: '',
      name: '',
      address: '',
      phone: '',
      timing: '10:00 AM - 5:00 PM',
      manager: '',
      coordsX: '50',
      coordsY: '50',
      isHQ: false
    });
    setIsModalOpen(true);
  };

  const handleOpenEdit = (branch) => {
    setEditBranch(branch);
    setFormData({
      city: branch.city || '',
      name: branch.name || '',
      address: branch.address || '',
      phone: branch.phone || '',
      timing: branch.timing || '10:00 AM - 5:00 PM',
      manager: branch.manager || '',
      coordsX: branch.coords?.x !== undefined ? String(branch.coords.x) : '50',
      coordsY: branch.coords?.y !== undefined ? String(branch.coords.y) : '50',
      isHQ: !!branch.isHQ
    });
    setIsModalOpen(true);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const branchData = {
      city: formData.city.trim(),
      name: formData.name.trim(),
      address: formData.address.trim(),
      phone: formData.phone.trim(),
      timing: formData.timing.trim(),
      manager: formData.manager.trim(),
      coords: {
        x: Number(formData.coordsX) || 50,
        y: Number(formData.coordsY) || 50
      },
      isHQ: formData.isHQ
    };

    try {
      if (editBranch) {
        // Update existing document
        await setDoc(doc(db, 'branches', editBranch.id), {
          ...branchData,
          id: editBranch.id
        }, { merge: true });
        Swal.fire('Updated!', 'Branch has been updated successfully.', 'success');
      } else {
        // Create new document
        const id = branchData.city.toLowerCase().replace(/[^a-z0-9]+/g, '-') + '-' + Math.floor(1000 + Math.random() * 9000);
        await setDoc(doc(db, 'branches', id), {
          ...branchData,
          id: id
        });
        Swal.fire('Added!', 'New branch has been created successfully.', 'success');
      }
      setIsModalOpen(false);
    } catch (err) {
      console.error(err);
      Swal.fire('Error', 'Failed to save branch information', 'error');
    }
  };

  const handleDelete = async (branch) => {
    const result = await Swal.fire({
      title: 'Delete Branch?',
      text: `Are you sure you want to delete ${branch.name}? This action cannot be undone.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      cancelButtonColor: '#3085d6',
      confirmButtonText: 'Yes, delete it!'
    });

    if (result.isConfirmed) {
      try {
        await deleteDoc(doc(db, 'branches', branch.id));
        Swal.fire('Deleted!', 'Branch has been removed.', 'success');
      } catch (err) {
        console.error(err);
        Swal.fire('Error', 'Failed to delete branch', 'error');
      }
    }
  };

  // Filter list
  const filteredBranches = branches.filter(branch => {
    const query = searchQuery.toLowerCase();
    return (
      branch.city.toLowerCase().includes(query) ||
      branch.name.toLowerCase().includes(query) ||
      branch.address.toLowerCase().includes(query) ||
      branch.phone.includes(query) ||
      (branch.manager && branch.manager.toLowerCase().includes(query))
    );
  });

  return (
    <div className="space-y-8">
      {/* Header section */}
      <div className="flex flex-col lg:flex-row lg:items-center justify-between gap-6">
        <div>
          <h1 className="text-3xl font-bold text-primary-dark">Manage Branch</h1>
          <p className="text-gray-500 font-medium">Add, update, or remove branch details displaying on the public directory.</p>
        </div>
        
        <button
          onClick={handleOpenAdd}
          className="flex items-center gap-2 bg-primary hover:bg-primary-dark text-white px-6 py-3 rounded-2xl shadow-lg shadow-primary/20 transition-all active:scale-95 font-bold self-start lg:self-center"
        >
          <Plus className="w-5 h-5" />
          Add New Branch
        </button>
      </div>

      {/* Search & Stats Bar */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 bg-white p-4 rounded-[2rem] shadow-sm border border-gray-100">
        <div className="relative w-full md:w-96">
          <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" />
          <input
            type="text"
            placeholder="Search by city, name, phone..."
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full bg-gray-50 pl-12 pr-4 py-3.5 rounded-2xl border border-gray-200 focus:outline-none focus:ring-2 focus:ring-primary/20 text-sm font-semibold text-gray-800"
          />
        </div>

        <div className="flex items-center gap-6 px-4 self-end md:self-center">
          <div className="text-center">
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Total Branches</p>
            <p className="text-lg font-bold text-primary-dark">{branches.length}</p>
          </div>
          <div className="w-px h-8 bg-gray-100" />
          <div className="text-center">
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest">Head Office</p>
            <p className="text-lg font-bold text-secondary">
              {branches.filter(b => b.isHQ).length}
            </p>
          </div>
        </div>
      </div>

      {/* Grid of branch cards (CRUD layout resembling real cards) */}
      {loading ? (
        <div className="text-center py-20">
          <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
          <p className="text-gray-500 font-bold">Loading branches...</p>
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-8">
          <AnimatePresence>
            {filteredBranches.map((branch) => {
              const isHQ = branch.isHQ;
              return (
                <motion.div
                  key={branch.id}
                  layout
                  initial={{ opacity: 0, scale: 0.95 }}
                  animate={{ opacity: 1, scale: 1 }}
                  exit={{ opacity: 0, scale: 0.95 }}
                  className={`rounded-[2rem] p-6 border transition-all duration-300 flex flex-col justify-between min-h-[300px] h-full relative overflow-hidden group/card bg-white shadow-md shadow-slate-100 hover:shadow-xl ${
                    isHQ 
                      ? 'bg-gradient-to-br from-amber-50 to-orange-100/50 border-amber-200' 
                      : 'border-slate-100 hover:border-primary/20'
                  }`}
                >
                  <div>
                    {/* Header */}
                    <div className="flex justify-between items-start mb-3">
                      <div className={`p-2.5 rounded-xl bg-slate-50 text-slate-400 ${isHQ ? 'bg-amber-100/60 text-secondary' : 'text-primary bg-primary/5'}`}>
                        <Building className="w-5 h-5 shrink-0" />
                      </div>
                      
                      {isHQ && (
                        <span className="bg-secondary text-white text-[8px] xl:text-[9px] font-black px-3 py-1 rounded-full tracking-wider shadow-sm">
                          HEAD OFFICE
                        </span>
                      )}
                    </div>

                    {/* City Name */}
                    <h3 className="text-xl font-extrabold text-primary-dark group-hover/card:text-primary transition-colors duration-300 mb-2 leading-snug">
                      {branch.city}
                    </h3>
                    
                    {/* Branch Title */}
                    <h4 className="text-sm font-semibold text-gray-700 mb-3">{branch.name}</h4>

                    {/* Details list */}
                    <div className="space-y-2.5 text-xs text-slate-500 font-semibold mb-4 leading-relaxed">
                      <p className="line-clamp-3">{branch.address}</p>
                      
                      <div className="flex items-center gap-2 mt-2">
                        <Clock className="w-3.5 h-3.5 text-gray-400" />
                        <span>{branch.timing || '10:00 AM - 5:00 PM'}</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <User className="w-3.5 h-3.5 text-gray-400" />
                        <span>Manager: {branch.manager || 'N/A'}</span>
                      </div>

                      <div className="flex items-center gap-2">
                        <MapPin className="w-3.5 h-3.5 text-gray-400" />
                        <span>Coords: X: {branch.coords?.x ?? 50}, Y: {branch.coords?.y ?? 50}</span>
                      </div>
                    </div>
                  </div>

                  {/* Actions & Phone Footer */}
                  <div className="pt-4 border-t border-slate-100 flex flex-col gap-3 mt-4">
                    <div className="flex items-center gap-2 bg-slate-50 px-3 py-2 rounded-xl text-slate-600 font-bold text-xs select-none">
                      <Phone className="w-3.5 h-3.5 text-gray-400" />
                      <span>{branch.phone}</span>
                    </div>

                    <div className="flex gap-2">
                      <button
                        onClick={() => handleOpenEdit(branch)}
                        className="flex-1 py-2.5 bg-sky-50 text-sky-600 rounded-xl hover:bg-sky-100 transition-colors font-bold text-xs flex items-center justify-center gap-1.5 border border-sky-100"
                      >
                        <Edit className="w-3.5 h-3.5" />
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(branch)}
                        className="flex-1 py-2.5 bg-rose-50 text-rose-600 rounded-xl hover:bg-rose-100 transition-colors font-bold text-xs flex items-center justify-center gap-1.5 border border-rose-100"
                      >
                        <Trash2 className="w-3.5 h-3.5" />
                        Delete
                      </button>
                    </div>
                  </div>
                </motion.div>
              );
            })}
          </AnimatePresence>
          {filteredBranches.length === 0 && (
            <div className="col-span-full text-center py-16 text-slate-400 font-bold bg-white rounded-[2.5rem] border border-slate-100 shadow-sm">
              No matching branches found
            </div>
          )}
        </div>
      )}

      {/* Editor Modal */}
      {isModalOpen && createPortal(
        <div className="fixed inset-0 bg-primary-dark/60 backdrop-blur-sm z-[60] flex items-center justify-center p-4">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            className="bg-white rounded-[3rem] shadow-2xl w-full max-w-2xl overflow-hidden max-h-[90vh] flex flex-col"
          >
            <div className="p-8 border-b border-gray-100 flex items-center justify-between shrink-0">
              <h2 className="text-2xl font-bold text-primary-dark">
                {editBranch ? 'Edit Branch Details' : 'Add New Branch'}
              </h2>
              <button 
                onClick={() => setIsModalOpen(false)} 
                className="p-2 hover:bg-gray-100 rounded-xl transition-colors"
              >
                <X className="w-6 h-6 text-gray-400" />
              </button>
            </div>

            <form onSubmit={handleSubmit} className="p-8 space-y-6 overflow-y-auto">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                
                {/* Branch name */}
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Branch Name</label>
                  <input
                    type="text"
                    required
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    placeholder="e.g. Yelavi Village Branch"
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800"
                  />
                </div>

                {/* City name */}
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">City / Region</label>
                  <input
                    type="text"
                    required
                    value={formData.city}
                    onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                    placeholder="e.g. Yelavi"
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800"
                  />
                </div>

                {/* Phone */}
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Phone Number</label>
                  <input
                    type="text"
                    required
                    value={formData.phone}
                    onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                    placeholder="e.g. 9075251097"
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800"
                  />
                </div>

                {/* Manager */}
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Branch Manager</label>
                  <input
                    type="text"
                    required
                    value={formData.manager}
                    onChange={(e) => setFormData({ ...formData, manager: e.target.value })}
                    placeholder="e.g. Shri. K. D. Patil"
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800"
                  />
                </div>

                {/* Timing */}
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Operational Hours</label>
                  <input
                    type="text"
                    required
                    value={formData.timing}
                    onChange={(e) => setFormData({ ...formData, timing: e.target.value })}
                    placeholder="e.g. 10:00 AM - 5:00 PM"
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800"
                  />
                </div>

                {/* Head Office Checkbox */}
                <div className="flex items-center pt-8 pl-2">
                  <label className="flex items-center gap-3 cursor-pointer group select-none">
                    <input
                      type="checkbox"
                      checked={formData.isHQ}
                      onChange={(e) => setFormData({ ...formData, isHQ: e.target.checked })}
                      className="w-5 h-5 rounded border-gray-300 text-primary focus:ring-primary"
                    />
                    <span className="text-sm font-bold text-gray-700 group-hover:text-primary transition-colors">Is Head Office / HQ?</span>
                  </label>
                </div>

                {/* Coords X */}
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Map Position X (0 - 100)</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    required
                    value={formData.coordsX}
                    onChange={(e) => setFormData({ ...formData, coordsX: e.target.value })}
                    placeholder="e.g. 34"
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800"
                  />
                </div>

                {/* Coords Y */}
                <div className="space-y-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Map Position Y (0 - 100)</label>
                  <input
                    type="number"
                    min="0"
                    max="100"
                    required
                    value={formData.coordsY}
                    onChange={(e) => setFormData({ ...formData, coordsY: e.target.value })}
                    placeholder="e.g. 44"
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800"
                  />
                </div>

                {/* Address Full */}
                <div className="space-y-2 md:col-span-2">
                  <label className="text-sm font-bold text-gray-700 ml-1">Branch Address</label>
                  <textarea
                    required
                    rows="3"
                    value={formData.address}
                    onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                    placeholder="Enter complete postal address of the branch..."
                    className="w-full px-5 py-3.5 bg-gray-50 border border-gray-200 rounded-2xl focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm font-semibold text-gray-800 resize-none"
                  />
                </div>

              </div>

              <div className="flex gap-4 pt-4 shrink-0">
                <button
                  type="button"
                  onClick={() => setIsModalOpen(false)}
                  className="flex-1 px-8 py-4 bg-gray-100 text-gray-600 font-bold rounded-2xl hover:bg-gray-200 transition-all text-sm"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="flex-[2] px-8 py-4 bg-primary text-white font-bold rounded-2xl hover:bg-primary-dark shadow-lg shadow-primary/20 transition-all active:scale-95 text-sm"
                >
                  {editBranch ? 'Save Changes' : 'Create Branch'}
                </button>
              </div>
            </form>
          </motion.div>
        </div>,
        document.body
      )}
    </div>
  );
};

export default BranchManager;
